import * as React from "react";

import type { DesignaliProps } from "../../types";

export const GitCompareArrows = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <circle cx="5" cy="6" r="3" />
        <path d="M12 6h5a2 2 0 0 1 2 2v7" />
        <path d="m15 9-3-3 3-3" />
        <circle cx="19" cy="18" r="3" />
        <path d="M12 18H7a2 2 0 0 1-2-2V9" />
        <path d="m9 15 3 3-3 3" />
      </svg>
    );
  },
);

export default GitCompareArrows;
